module.exports = __webpack_public_path__ + "assets/img/logo-mini.905ace6d.svg";